import { i18n } from "../../../translate/i18n";

export const validateCampaignForm = (values, { campaignAiChoice, campaignType }) => {
  const errors = {};
  const aiModeActive = campaignAiChoice === 'yes';

  // Validar nombre
  if (!values.name || values.name.trim() === "") {
    errors.name = "El nombre de la campaña es obligatorio";
  } else if (values.name.trim().length < 3) {
    errors.name = "El nombre debe tener al menos 3 caracteres";
  } else if (values.name.trim().length > 40) {
    errors.name = "El nombre no puede exceder 40 caracteres";
  }

  // Validar conexión
  if (!values.whatsappId || values.whatsappId === "") {
    errors.whatsappId = "La conexión es obligatoria";
  }

  // Validar fecha programada
  if (!values.scheduledAt || values.scheduledAt === "") {
    errors.scheduledAt = "La fecha programada es obligatoria";
  }

  // Validar lista de contactos o etiquetas
  const hasContactOrTag = (values.contactListId && values.contactListId !== "") ||
                         (values.tagListId && values.tagListId !== "");
  if (!hasContactOrTag) {
    errors.contactListId = "Debe seleccionar una lista de contactos o una lista de etiquetas";
  }

  // Validar al menos un mensaje
  const hasMessage = aiModeActive
    ? !!(values.message1 && values.message1.trim() !== "")
    : (
        (values.message1 && values.message1.trim() !== "") ||
        (values.message2 && values.message2.trim() !== "") ||
        (values.message3 && values.message3.trim() !== "") ||
        (values.message4 && values.message4.trim() !== "") ||
        (values.message5 && values.message5.trim() !== "")
      );
  if (!hasMessage) {
    errors.message1 = "Debe ingresar al menos un mensaje";
  }

  if (aiModeActive) {
    const pid = values.promptId !== undefined && values.promptId !== null && values.promptId !== ""
      ? String(values.promptId)
      : "";
    if (!pid) {
      errors.promptId = i18n.t("campaigns.dialog.ai.errors.promptSendRequired");
    }
    const rid =
      values.replyPromptId !== undefined && values.replyPromptId !== null && values.replyPromptId !== ""
        ? String(values.replyPromptId)
        : "";
    if (!rid) {
      errors.replyPromptId = i18n.t("campaigns.dialog.ai.errors.replyPromptRequired");
    }
    if (!values.autoTagEnabled) {
      errors.autoTagEnabled = "Con IA dinámica el etiquetado ante respuesta es obligatorio.";
    }
    const tid =
      values.autoTagId !== undefined && values.autoTagId !== null && values.autoTagId !== ""
        ? String(values.autoTagId)
        : "";
    if (!tid) {
      errors.autoTagId = "Seleccione la etiqueta a vincular al responder.";
    }
  }

  const isRecurrentCampaign = values.isRecurring || values.tipo === 'RECURRENTE' || campaignType === 'RECURRENTE';
  if (isRecurrentCampaign) {
    if (!values.recurrenceType || values.recurrenceType === "") {
      errors.recurrenceType = "El tipo de recurrencia es obligatorio";
    }

    // ✅ Validar intervalo: convertir a número y validar
    // Permitir valores 1, 2, 3, etc. (incluyendo 1)
    const intervalValue = values.recurrenceInterval;
    if (intervalValue === undefined || intervalValue === null || intervalValue === "") {
      errors.recurrenceInterval = "El intervalo es obligatorio";
    } else {
      // Convertir a número (manejar string "1", número 1, etc.)
      let intervalNum;
      if (typeof intervalValue === 'string') {
        const trimmed = intervalValue.trim();
        if (trimmed === '') {
          errors.recurrenceInterval = "El intervalo es obligatorio";
        } else {
          intervalNum = parseInt(trimmed, 10);
        }
      } else {
        intervalNum = Number(intervalValue);
      }

      // Validar solo si se pudo convertir
      if (intervalNum !== undefined) {
        if (isNaN(intervalNum) || intervalNum < 1) {
          errors.recurrenceInterval = "El intervalo debe ser mayor a 0";
        } else if (!Number.isInteger(intervalNum)) {
          errors.recurrenceInterval = "El intervalo debe ser un número entero";
        }
        // ✅ Si intervalNum === 1, NO agregar error (permitir valor 1)
      }
    }

    if (values.recurrenceType === "semanal" && !values.recurrenceDaysOfWeek) {
      errors.recurrenceDaysOfWeek = "Debe seleccionar al menos un día de la semana";
    }

    if (values.recurrenceType === "mensual" && values.recurrenceDayOfMonth) {
      if (values.recurrenceDayOfMonth < 1 || values.recurrenceDayOfMonth > 31) {
        errors.recurrenceDayOfMonth = "El día del mes debe estar entre 1 y 31";
      }
    }
  }

  // Regla anti-spam: intervalos mínimos de 30 segundos
  const msgInterval = parseInt(values.messageInterval, 10);
  if (!isNaN(msgInterval) && msgInterval < 30) {
    errors.messageInterval = "El intervalo inicial no puede ser menor a 30 segundos (mínimo anti-spam de WhatsApp).";
  }
  const gtInterval = parseInt(values.greaterInterval, 10);
  if (!isNaN(gtInterval) && gtInterval < 30) {
    errors.greaterInterval = "El intervalo mayor no puede ser menor a 30 segundos (mínimo anti-spam de WhatsApp).";
  }

  return errors;
};
